"use client";

import { motion } from "framer-motion";
import EditableElement from "@/components/customize/EditableElement";

export default function Quote({ 
  quoteText = "Dan di antara tanda-tanda (kebesaran)-Nya ialah Dia menciptakan untukmu pasangan hidup dari jenismu sendiri supaya kamu merasa tenteram kepadanya, dan Dia menjadikan di antaramu rasa kasih dan sayang. Sungguh, pada yang demikian itu benar-benar terdapat tanda-tanda (kebesaran Allah) bagi kaum yang berpikir.", 
  quoteAuthor = "— QS. Ar-Rum: 21",
  __isEditable = false,
  __sectionId,
  __onFieldEdit,
  __onFieldChange,
  __focusFieldName,
  __isMobile = false
}) {
    const fadeInUp = {
        hidden: { opacity: 0, y: 40 },
        show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    };

    return (
        <div className="bg-white/10 backdrop-blur text-white text-xs relative flex items-start justify-end px-8 py-4">
            <motion.div
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                variants={fadeInUp}>
                <EditableElement
                  type="text"
                  value={quoteText}
                  onChange={(val) => __onFieldChange?.(__sectionId, "quoteText", val)}
                  isEditable={__isEditable}
                  fieldName="quoteText"
                  onEditStart={() => __onFieldEdit?.(__sectionId, "quoteText")}
                  isActive={__focusFieldName === "quoteText"}
                  isMobile={__isMobile}
                  useContentEditable={true}
                  multiline={true}
                  className="block"
                >
                  <p>&ldquo;{quoteText}&rdquo;</p>
                </EditableElement>
                <EditableElement
                  type="text"
                  value={quoteAuthor}
                  onChange={(val) => __onFieldChange?.(__sectionId, "quoteAuthor", val)}
                  isEditable={__isEditable}
                  fieldName="quoteAuthor"
                  onEditStart={() => __onFieldEdit?.(__sectionId, "quoteAuthor")}
                  isActive={__focusFieldName === "quoteAuthor"}
                  isMobile={__isMobile}
                  useContentEditable={true}
                  className="block mt-2"
                >
                  <p className="font-bold">{quoteAuthor}</p>
                </EditableElement>
            </motion.div>
        </div>
    );
}
